/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import styles from "./CandidateCard.module.scss";
import ActionMenu from "../Common/ActionMenu";
import { MyModal } from "../Common/Model/MyModal";
import ModalContainer from "../Common/Model/ModalContainer";
import { MdOutlineContentCopy } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {
  copyToClipboard,
  dateFormate,
  dateFormateDD,
  decryptedAdminID,
  dMMMYYYY_formate,
  getSubStageBadge,
  hideDateFor,
  renderInterviewDate,
  showReasonFor,
  stageMenuOptions,
  textTruncate,
} from "../../utility";
import { Autocomplete, TextField } from "@mui/material";
import { getReasons } from "../../services/candidateServices";
import SuccessTick from "../success_tick";
import { updateInterviewStatus } from "../../services/interviewServices";
import { fetchPipeline } from "../../redux-store/slices/pipelineSlice";
import { useDispatch } from "react-redux";
import CreateFollowUp from "../../pages/NewFollowUp/CreateFollowUp";
import { useSelector } from "react-redux";
import InterviewCardModal from "../../pages/Candidate/NewCanInterview/InterviewCardModel";
import {
  GetInterviewDetails,
  putInterviewCardDetails,
} from "../../apiServices";
import dayjs from "dayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

const CandidateCard = ({ data, stage, menu, activeTab, onSelectCandidate , reload}) => {
  console.log(stage,"stagee");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adminID = decryptedAdminID();

const { pipelineByType, currentType } = useSelector((state) => state.pipeline);

const columnFilters =
  pipelineByType[currentType]?.columnFilters || {};

  const { filters } = useSelector((state) => state.pipeline);


  // ✅ STATES
  const [status, setStatus] = useState({
    eventDate: "",
    reasonId: null,
    notes: "",
  });

  const [errors, setErrors] = useState({
    eventDate: "",
    reasonId: "",
  });

  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [followUpSuccess, setFollowUpSuccess] = useState(false);
  const [modalType, setModalType] = useState("");
  const [optionList, setOptionList] = useState([]);

  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [openFollowUpModal, setOpenFollowUpModal] = useState(false);
  const [showerrMsg, setShowerrMsg] = useState(false);
  const [Interviewmessage, setInterviewmessage] = useState("");

  // STATES
  const [modalChange, setmodalChange] = useState(false);

  const [currentInterviewId, setCurrentInterviewId] = useState("");
  const [interviewCard, setInterviewCard] = useState({
    show: false,
  });

  const [interviewcardDetails, setInterviewcardDetails] = useState({});
  const [formData, setFormData] = useState({
    jobCategory: "",
    contactPersonName: "",
    // time: dayjs(),
    time: dayjs().set("hour", 9).set("minute", 30).set("second", 0),
  });

  const today = new Date().toISOString().split("T")[0];

  const isFutureOnlyAllowed = ["Reschedule Interview", "Will join"].includes(
    modalType,
  );

  // ✅ DEFAULT DATE
  useEffect(() => {
    const noDefaultDateFor = ["Reschedule Interview", "Will join"];

    if (!noDefaultDateFor.includes(modalType)) {
      const today = new Date().toISOString().split("T")[0];

      setStatus((prev) => ({
        ...prev,
        eventDate: today,
      }));
    } else {
      // 🔥 clear date for these cases
      setStatus((prev) => ({
        ...prev,
        eventDate: "",
      }));
    }
  }, [modalType]);

  // ✅ FETCH REASONS
  useEffect(() => {
    if (showReasonFor.includes(modalType)) {
      fetchReasons();
    }
  }, [modalType]);

  const fetchReasons = async () => {
    try {
      const res = await getReasons(modalType);
      setOptionList(res.data || res || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleOpenFollowUpModal = () => {
    setOpenFollowUpModal(true);
  };
  // ✅ OPEN MODAL
  const handleOpenModal = (item, candidateData) => {
    setSelectedAction(item);
    setSelectedCandidate(candidateData);
    setModalType(item.label);
    setOpenModal(true);

    const noDefaultDateFor = ["Reschedule Interview", "Will join"];

    const today = new Date().toISOString().split("T")[0];

    setStatus({
      eventDate: noDefaultDateFor.includes(item.label) ? "" : today,
      reasonId: null,
      notes: "",
    });

    setErrors({
      eventDate: "",
      reasonId: "",
    });
  };

  // ✅ INPUT CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;

    setStatus((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleAutoChange = (event, value) => {
    setStatus((prev) => ({
      ...prev,
      reasonId: value?.id || null,
    }));

    setErrors((prev) => ({
      ...prev,
      reasonId: "",
    }));
  };

  const toInt = (val) => (val ? Number(val) : null);

  // ✅ SUBMIT
  const handleSubmit = async () => {
    let newErrors = {
      eventDate: "",
      reasonId: "",
    };

    let isValid = true;

    if (!hideDateFor.includes(modalType) && !status.eventDate) {
      newErrors.eventDate = "Date is required";
      isValid = false;
    }

    if (showReasonFor.includes(modalType) && !status.reasonId) {
      newErrors.reasonId = "Reason is required";
      isValid = false;
    }

    setErrors(newErrors);
    if (!isValid) return;

    const selectedReason = optionList.find(
      (item) => item.id === status.reasonId,
    );

    const payload = {
      interview_id: selectedCandidate?.interview_id,
      from_stage_id: toInt(selectedCandidate?.current_stage_id),
      from_sub_stage_id: toInt(selectedCandidate?.current_sub_stage_id),
      to_stage_id: selectedAction?.stage_id
        ? toInt(selectedAction.stage_id)
        : toInt(selectedCandidate?.current_stage_id),

      to_sub_stage_id: selectedAction?.sub_stage_id
        ? toInt(selectedAction.sub_stage_id)
        : null,
      moved_by: toInt(adminID),
      reason_id: status.reasonId || null,
      custom_reason: selectedReason?.reason_name || null,
      notes: status.notes || null,
      event_date: dateFormate(status.eventDate).trim(),
    };

    setLoading(true);
    try {
      const res = await updateInterviewStatus(payload);

      // ❗ handle API-level failure
      if (!res?.success) {
        setShowerrMsg(true);
        setInterviewmessage(res?.message || "Something went wrong!");
        return;
      }

      setSuccess(true);

      const today = new Date().toISOString().split("T")[0];
      const fromStage = selectedCandidate?.current_stage_id;
const toStage = selectedAction?.stage_id;

setTimeout(async () => {
  setOpenModal(false);

  // 🔹 FROM STAGE REFRESH


  // 🔹 TO STAGE REFRESH
  // if (toStage && toStage !== fromStage) {
  //   await dispatch(fetchPipeline({
  //     ...(columnFilters[toStage] || {}), 
  //     stage_id: toStage,
  //     offset: 0
  //   }));
  // }
    await dispatch(fetchPipeline({
    ...(columnFilters[fromStage] || {}), 
    stage_id: parseInt(fromStage),
    offset: 0
  }));

    if (toStage && toStage !== fromStage) {
    await dispatch(fetchPipeline({
      ...(columnFilters[toStage] || {}), 
      stage_id: toStage,
      offset: 0
    }));
  }

  setSuccess(false);
}, 1500);

//       setTimeout(async () => {
//         setOpenModal(false);

// await dispatch(fetchPipeline({
//   ...filters,
//   stage_id: selectedCandidate?.current_stage_id, 
//   offset: 0
// }));


//         // await dispatch(fetchPipeline({ offset: 0 }));

//         // await dispatch(
//         //   fetchPipeline({
//         //     stage_id: 8,
//         //     date_from: "2025-12-01",
//         //     date_to: today,
//         //   }),
//         // );

//         setSuccess(false);
//       }, 1500);
    } catch (error) {
      console.error(error);

      // ✅ backend error message (if thrown)
      alert(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong!",
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchInterviewDetails = async (id) => {
    try {
      const res = await GetInterviewDetails(id);
      const data = res.data || res;

      setInterviewcardDetails(data);

      setFormData({
        jobCategory: data?.job?.jobCategory || "",
        contactPersonName: data?.interview?.contactPersonName || "",
        // time: data.time ? dayjs(data.time, "hh:mm A") : dayjs(),
        time: data.time
          ? dayjs(data.time, "hh:mm A")
          : dayjs().set("hour", 9).set("minute", 30).set("second", 0),
      });
    } catch (err) {
      console.error(err);
    }
  };
  // ✅ MENU CONFIG

  let menuOptions = [];

  if (activeTab === "exit") {
    const stageName = stage?.stage?.trim();
    const fromStageId = Number(data?.from_stage_id);
    const toStageId = Number(data?.to_stage_id);

    const isValidExitStage =
      stageName === "Not Interested" || stageName === "Offer Rejected" || stageName === "Left";

    // console.log("Card:", data.name, "| Stage:", stageName, "| From:", fromStageId);

    if (isValidExitStage) {
      if (fromStageId === 8) {
        menuOptions = [
          {
            label: "Interview Attended",
            action: () =>
              handleOpenModal(
                { label: "Interview Attended", stage_id: 14 },
                data,
              ),
          },
        ];
      } else if (fromStageId === 14) {
        menuOptions = [
          {
            label: "Selected",
            action: () =>
              handleOpenModal({ label: "Selected", stage_id: 18 }, data),
          },
        ];
      } else if (fromStageId === 18) {
        menuOptions = [
          {
            label: "Offer Accepted",
            action: () =>
              handleOpenModal({ label: "Offer Accepted", stage_id: 22 }, data),
          },
        ];
      } else if (fromStageId === 22) {
        menuOptions = [
          {
            label: "Joined",
            action: () =>
              handleOpenModal({ label: "Joined", stage_id: 27 }, data),
          },
        ];
      }else if (toStageId === 29) {
        menuOptions = [
          {
            label: "Undo",
            action: () =>
              handleOpenModal({ label: "Undo", stage_id: 27 }, data),
          },
        ];
      } else {
        // ✅ Default Undo
        menuOptions = [
          {
            label: "Undo",
            action: () => handleOpenModal({ label: "Undo", stage_id: 8 }, data),
          },
        ];
      }
    } else {
      menuOptions = [];
    }
  } else {
    menuOptions = (stageMenuOptions[stage.stage] || []).map((item) => ({
      label: item.label,
      action:
        item.label === "Create Follow-up"
          ? () => handleOpenFollowUpModal()
          : item.label === "Interview Card"
            ? () => {
                setCurrentInterviewId(data.interview_id);
                fetchInterviewDetails(data.interview_id);
                setmodalChange(true);
              }
            : () => handleOpenModal(item, data),
    }));
  }

  // INPUT CHANGE
  const handleInterviewDataChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTimeChange = (newTime) => {
    if (newTime) {
      setFormData((prev) => ({ ...prev, time: newTime }));
    }
  };

  // ✅ SAVE & PREVIEW
  const handleSubmitcard = () => {
    setLoading(true);

    const payload = {
      id: currentInterviewId,
      jobCategory: formData.jobCategory,
      interviewTime: dayjs(formData.time).format("hh:mm A"),
      contactName: formData.contactPersonName,
    };

    putInterviewCardDetails(payload)
      .then(() => {
        // close edit modal
        setmodalChange(false);

        // open preview
        setInterviewCard({ show: true });
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };
  const subStageLabel = data.current_sub_stage || "";
  const badge = getSubStageBadge(subStageLabel);
  const handleClick = () => {
    if (typeof onSelectCandidate === "function") {
      onSelectCandidate(data);
    } else {
      console.error("❌ onSelectCandidate missing at CandidateCard");
    }
  };
  return (
    <>
      <div
        className={`${styles.card} ${activeTab === "exit" ? styles.exitCard : styles.activeCard}`}
      >
        <div className={styles["d-flex"]}>
          <div
            className={`${activeTab === "exit" ? styles.Exitname : styles.Activename} `}
            // onClick={goToDetail}
            onClick={handleClick}
            title={data.name}
          >
            {textTruncate(data.name, 18)}
          </div>

          <div className={styles.sourceMenu}>
            {/* <span className={styles.date}>{dMMMYYYY_formate(data.date)}</span> */}
            <span className={styles.date}>
              {stage.stage_id === 8
                ? renderInterviewDate(data.date)
                : dMMMYYYY_formate(data.date)}
            </span>
            {menu && menuOptions.length > 0 && (
              <ActionMenu options={menuOptions} />
            )}
          </div>
        </div>

        <div className={styles.role}>{data.role}</div>

        <div className={styles["d-flex"]}>
          <div className={styles.phone}>
            {data.phone}{" "}
            <MdOutlineContentCopy
              style={{ cursor: "pointer" }}
              onClick={() => copyToClipboard(data.phone)}
            />
          </div>
          {data.current_sub_stage != null && (
            <div>
              <span
                style={{
                  backgroundColor: badge.bg,
                  color: badge.color,
                  padding: "4px 8px",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "600",
                  display: "inline-block",
                  minWidth: "40px",
                  textAlign: "center",
                }}
                title={data.current_sub_stage}
              >
                {badge.label}
              </span>
            </div>
          )}
        </div>

        <div
          className={styles.headerRow}
          style={{
            display: "flex",
            justifyContent: data.companyName ? "space-between" : "flex-end",
            alignItems: "center",
            gap: "2px",
          }}
        >
          {data.companyName && (
            <div className={styles.companyWrapper}>
              <span className={styles.companyName}>{data.companyName}</span>
            </div>
          )}

          <span className={styles.assignedTo}>
            <span
              className={`${activeTab === "exit" ? styles.assignedToFirstLetterExit : styles.assignedToFirstLetter}`}
              title={data?.admin}
            >
              {data?.admin?.charAt(0)?.toUpperCase() || "?"}
            </span>{" "}
          </span>
        </div>
      </div>

      {/* ✅ MODAL */}
      {openModal && (
        <MyModal>
          <ModalContainer onClose={() => setOpenModal(false)}>
            <div className="text-center">
              <b>{modalType}</b>
            </div>
            <br />
            <p>
              Are you sure you want to move this candidate{" "}
              <b>{selectedCandidate?.name}</b>&nbsp;?
            </p>

            {!hideDateFor.includes(modalType) && (
              // <TextField
              //   fullWidth
              //   type="date"
              //   name="eventDate"
              //   value={status.eventDate}
              //   onChange={handleChange}
              //   error={!!errors.eventDate}
              //   helperText={errors.eventDate}
              // />
              <TextField
                fullWidth
                type="date"
                name="eventDate"
                value={status.eventDate}
                onChange={handleChange}
                error={!!errors.eventDate}
                helperText={errors.eventDate}
                inputProps={{
                  min: isFutureOnlyAllowed ? today : undefined, 
                  max: !isFutureOnlyAllowed ? today : undefined, 
                }}
              />
            )}

            {showReasonFor.includes(modalType) && (
              <Autocomplete
                options={optionList}
                getOptionLabel={(o) => o.reason_name || ""}
                onChange={handleAutoChange}
                className="mt-3"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Reason"
                    error={!!errors.reasonId}
                    helperText={errors.reasonId}
                  />
                )}
              />
            )}

            <TextField
              fullWidth
              name="notes"
              label="Notes"
              className="mt-3"
              value={status.notes}
              onChange={handleChange}
            />

            <div className="d-flex justify-content-end gap-2 mt-2">
              <button
                onClick={() => setOpenModal(false)}
                className={styles.cancelButton}
              >
                No
              </button>

              <button
                onClick={handleSubmit}
                disabled={loading}
                className={styles.SubmitButton}
              >
                {loading ? "Saving..." : "Yes"}
              </button>
            </div>
          </ModalContainer>
        </MyModal>
      )}

      {success && (
        <MyModal>
          <ModalContainer zIndex={1000}>
            <SuccessTick HeadText="Successfully Moved!" />
          </ModalContainer>
        </MyModal>
      )}
      {followUpSuccess && (
        <MyModal>
          <ModalContainer>
            <SuccessTick HeadText="Follow-up Created Successfully!" />
          </ModalContainer>
        </MyModal>
      )}

      {openFollowUpModal && (
        <MyModal>
          <ModalContainer onClose={() => setOpenFollowUpModal(false)}>
            <CreateFollowUp
              entityId={data.interview_id}
              stageId={data.current_stage_id}
              candidateId={data.candidate_id} // ✅ Added candidate_id
              onSuccess={() => {
                setOpenFollowUpModal(false);
                setFollowUpSuccess(true); // ✅ Show follow-up success message
                setTimeout(() => setFollowUpSuccess(false), 2000);
              }}
              onCancel={() => setOpenFollowUpModal(false)}
            />
          </ModalContainer>
        </MyModal>
      )}

      {modalChange && (
        <MyModal>
          <ModalContainer>
            <div style={{ width: "450px" }}>
              <div className="text-center mb-2">
                <b>Interview Card Edit</b>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <b>Candidate :</b>
                </div>
                <div className="col-sm-8">
                  {interviewcardDetails?.candidate?.firstName}
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <b>Company :</b>
                </div>
                <div className="col-sm-8">
                  {interviewcardDetails?.job?.companyName}
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <b>Date :</b>
                </div>
                <div className="col-sm-8">
                  {dateFormateDD(
                    interviewcardDetails?.interview?.interviewDate,
                  )}
                </div>
              </div>

              <TextField
                label="Job Category"
                name="jobCategory"
                fullWidth
                margin="normal"
                value={formData.jobCategory}
                onChange={handleInterviewDataChange}
              />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["TimePicker"]}>
                  <TimePicker
                    label="Time"
                    value={formData.time}
                    onChange={handleTimeChange}
                  />
                </DemoContainer>
              </LocalizationProvider>

              <TextField
                label="Contact Person"
                name="contactPersonName"
                fullWidth
                margin="normal"
                value={formData.contactPersonName}
                onChange={handleInterviewDataChange}
              />

              <div className="d-flex justify-content-end gap-2 mt-2">
                <button
                  className="btn btn-danger"
                  onClick={() => setmodalChange(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={handleSubmitcard}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save & Preview"}
                </button>
              </div>
            </div>
          </ModalContainer>
        </MyModal>
      )}

      {showerrMsg && (
        <>
          <MyModal>
            <ModalContainer
              zIndex={1000}
              onClose={() => {
                setShowerrMsg(false);
                setInterviewmessage("");
              }}
            >
              <div>
                {Interviewmessage}

                <div className="d-flex justify-content-end align-items-center ">
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      setShowerrMsg(false);
                      setInterviewmessage("");
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </ModalContainer>
          </MyModal>
        </>
      )}
      {/* ✅ PREVIEW MODAL */}
      <InterviewCardModal
        open={interviewCard.show}
        interviewId={currentInterviewId}
        onClose={() => setInterviewCard({ show: false })}
        details={{
          ...interviewcardDetails,
          jobCategory: formData.jobCategory,
          contactPersonName: formData.contactPersonName,
          time: dayjs(formData.time).format("hh:mm A"),
        }}
      />
    </>
  );
};

export default CandidateCard;
